import React from "react";

const RadioButtonUI = ({
  leadingIcon,
  checkedIcon,
  radioClass,
  content = "",
  subContent = "",
  contentClass = "",
  checked = false,
  onRadioClick,
}) => {
  return (
    <div className="p-1 cursor-pointer" onClick={onRadioClick}>
      <div className={`${radioClass} relative rounded flex p-2 items-center gap-2`}>
        {leadingIcon && <div>{leadingIcon}</div>}
        <div className="flex flex-col">
          <div className={`${contentClass}`}>{content}</div>
          <div className={`${contentClass}`}>{subContent}</div>
        </div>
        <div className="absolute right-1">
          {checked ? (
            <div>{checkedIcon}</div>
          ) : (
            <div className="w-5 h-5 mr-[2px] rounded-full border border-grey-border" />
          )}
        </div>
      </div>
    </div>
  );
};

export default RadioButtonUI;
